.score\: {
  &null {
    background: var(--moderate) !important;
  }
  &300 {
    background: orange !important;
  }
  &400 {
    background: red !important;
  }
  &500 {
    background: brown !important;
  }
  &600 {
    background: purple !important;
  }
  &700 {
    background: blue !important;
  }
  &800 {
    background: green !important;
  }
}

.with-avatar {
  > * {
    vertical-align: middle;
  }
}
